import React from 'react';
import { IEstimateButton } from './EstimateButton.interface';
import styles from './EstimateButton.module.scss';
import { Button } from '@zurich-primitives/button';
import { getCurrentFile, getInputSize, useAppSelector } from 'app/redux';

export const EstimateButton: React.FC<IEstimateButton> = ({ onClick }) => {
  const currentFile = useAppSelector(getCurrentFile);
  const inputSize = useAppSelector(getInputSize);

  return (
    <div className={styles.wrapper}>
      <Button
        onClick={onClick}
        className={styles['calculate-btn']}
        disabled={currentFile == null && inputSize == null}
      >
        <Button.Label>Estimate Cost</Button.Label>
      </Button>
    </div>
  );
};
